import app from './app';
import store from './store';
import router from './router';
import './directives';
import './configs';
import vantComponents from './components/vant/index';
import './assets/css/common.less'; // 引入自定义样式（包括vant变量）

Object.entries(vantComponents).forEach(([key, value]) => {
    app.component(key, value);
});

app.use(store)
    .use(router)
    .mount('#app');
